<template>
  <div class="paper-syllabus-final-verify-arrange-add" v-loading="loading" element-loading-text="数据加载中，请稍等...">
    <div class="cont" v-if="teacherList.length">
      <el-form size="mini" label-width="100px" label-suffix="：" :model="form" :rules="rules" ref="form">
        <el-form-item label="主审教师" prop="chiefReviewerId" required>
          <el-select v-model="form.chiefReviewerId" placeholder="请选择主审教师" @change="validateTeachers">
            <el-option v-for="teacher in teacherList" :key="teacher.id" :label="teacher.name" :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="副审一教师" prop="deputyReviewerOneId" required>
          <el-select v-model="form.deputyReviewerOneId" placeholder="请选择副审一教师" @change="validateTeachers">
            <el-option v-for="teacher in teacherList" :key="teacher.id" :label="teacher.name" :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="副审二教师" prop="deputyReviewerTwoId" required>
          <el-select v-model="form.deputyReviewerTwoId" placeholder="请选择副审二教师" @change="validateTeachers">
            <el-option v-for="teacher in teacherList" :key="teacher.id" :label="teacher.name" :value="teacher.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" :loading="committing" @click="handleSubmit">{{ committing ? '提交中...' : '提交' }}</el-button>
      </div>
    </div>
    <Hint v-else v-show="errorMsg">{{ errorMsg }}</Hint>
  </div>
</template>

<script>
import Hint from '../../../../../../../../elements/Hint.vue'
export default {
  name: 'PaperSyllabusFinalVerifyArrangeAdd',
  components: {
    Hint
  },
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    extraId: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      committing: false,
      errorMsg: '',
      teacherList: [],
      form: {
        chiefReviewerId: '',
        deputyReviewerOneId: '',
        deputyReviewerTwoId: ''
      },
      rules: {
        chiefReviewerId: [
          { required: true, message: '请选择主审教师', trigger: 'change' }
        ],
        deputyReviewerOneId: [
          { required: true, message: '请选择副审一教师', trigger: 'change' }
        ],
        deputyReviewerTwoId: [
          { required: true, message: '请选择副审二教师', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('hidePopover')
    },
    validateTeachers () {
      const { chiefReviewerId, deputyReviewerOneId, deputyReviewerTwoId } = this.form
      const ids = [chiefReviewerId, deputyReviewerOneId, deputyReviewerTwoId].filter(id => id)
      const uniqueIds = new Set(ids)
      if (ids.length === 3 && ids.length !== uniqueIds.size) {
        this.$message.warning('主审、副审一、副审二不能是同一个教师')
        return false
      }
      return true
    },
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/syllabus/finalVerify/arrange/queryTeacher',
        method: 'post',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.teacherList = response.data.teacherList || []
          if (!this.teacherList.length) {
            this.errorMsg = '暂无评审教师'
          }
        } else {
          this.errorMsg = response.data.message || '获取评审教师失败'
        }
      }, () => {
        this.errorMsg = '获取评审教师失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }
        if (!this.validateTeachers()) {
          return false
        }
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/paper/syllabus/finalVerify/arrange/saveArrange',
          method: 'post',
          data: this.$qs.stringify({
            chiefReviewerId: this.form.chiefReviewerId,
            deputyReviewerOneId: this.form.deputyReviewerOneId,
            deputyReviewerTwoId: this.form.deputyReviewerTwoId,
            postIds: this.extraId
          }, {arrayFormat: 'repeat'})
        }).then(response => {
          if (response.data && response.data.errorCode === 0) {
            this.$message.success(response.data.message || '提交成功')
            this.$emit('hidePopoverAndRefresh')
          } else {
            this.$message.error(response.data.message || '提交失败')
          }
        }, () => {
          this.$message.error('提交失败')
        }).finally(() => {
          this.committing = false
        })
      })
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.loadData()
        } else {
          this.form = {
            chiefReviewerId: '',
            deputyReviewerOneId: '',
            deputyReviewerTwoId: ''
          }
          this.$refs.form && this.$refs.form.clearValidate()
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.paper-syllabus-final-verify-arrange-add{
  height: 300px;
  &>.cont{
    height: 100%;
    display: flex;
    flex-direction: column;
    ::v-deep  .el-form{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      overflow-y: auto;
      &>.el-form-item{
        width: 100%;
        max-width: 400px;
        &>.el-form-item__label{
          font-size: 12px;
        }
        &>.el-form-item__content{
          &>.el-select{
            width: 100%;
          }
        }
      }
    }
    & > .footer{
      padding: 10px 0;
      text-align: center;
      background-color: #fff;
    }
  }
}
</style>
